import React from 'react'
import styled from 'styled-components'
import { Box } from 'grommet'
import { Close as CloseIcon, Trophy as TrophyIcon } from 'grommet-icons'

import TooltipButton from './TooltipButton' //use grommet tip less code..
import { device } from '../../theme/device'

const AllResultsButtonBox = styled(Box)`
  position: absolute;
  bottom: 1.5rem;
  left: 1.5rem;
  z-index: 11;
  -webkit-tap-highlight-color: transparent;
  @media (max-width: 1225px) {
    top: 2.5rem;
    right: 1.5rem;
    left: auto;
    bottom: auto;
    & > button {
      padding: 8px;
    }
  }
  @media (max-width: 1200px) {
    bottom: 2rem;
    left: 2rem;
    top: auto;
    right: auto;
  }
  @media (max-width: 1189px) {
    top: 2.5rem;
    right: 1.5rem;
    left: auto;
    bottom: auto;
    & > button {
      padding: 8px;
    }
  }
`

const Close = styled(CloseIcon)`
  width: 18px;
  height: 18px;
  @media ${device.medium} {
    width: 14px;
    height: 14px;
  }
`

const Trophy = styled(TrophyIcon)`
  width: 18px;
  height: 18px;
  @media ${device.medium} {
    width: 14px;
    height: 14px;
  }
`

const AllResultsButton = ({ openBox, isOpened }) => {
  return (
    <AllResultsButtonBox>
      <TooltipButton
        icon={
          isOpened ? <Close color="iconDark" /> : <Trophy color="iconDark" />
        }
        clicked={openBox}
        message={isOpened ? 'Close All Results' : 'Open All Results'}
        position="right"
        color="iconDark"
        inline={true}
      />
    </AllResultsButtonBox>
  )
}

export default AllResultsButton
